import { useCallback, useEffect, useState } from "react";
import { Dropoff } from "../models/Dropoff";
import PlotAPI from "../plotAPI";

interface useDropoffsProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useDropoffs = ({ projects, projectInfo }: useDropoffsProps) => {
    const [dropoffsByProject, setDropoffsByProject] = useState<{ unique_token: string; dropoffs: Dropoff[] }[]>([]);

    const refreshDropoffsByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectDropoffs(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((dropoffs) => {
                    return {
                        unique_token: project.unique_token,
                        dropoffs,
                    };
                })
            )
        ).then((dropoffs) => {
            setDropoffsByProject(dropoffs);
        });
    }, [projects]);

    useEffect(() => {
        refreshDropoffsByProject();
    }, [projects, refreshDropoffsByProject]);

    const dropoffsForProject = (projectId: string | number): Dropoff[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return dropoffsByProject.find((project) => project.unique_token === projectToken)?.dropoffs || [];
    };

    return {
        dropoffsByProject,
        dropoffsForProject,
        refreshDropoffsByProject,
    };
};

export default useDropoffs;
